import React from 'react';
import { useTranslation } from 'react-i18next';
import parameters from '../../../../config/parameters';
import { useParams } from "react-router-dom";
import { Link } from 'react-router-dom';
import Avatar from '../../../Units/Avatar';
import { getCurrentClub } from '../../../../store/selectors';
import { useSelector } from 'react-redux';

const PlayerTab = ({ player, selectedField, avatar}) => {
    const { t } = useTranslation();
   const {id: clubId} = useParams();
   const currentClub = useSelector(getCurrentClub);
   const role = currentClub.playerAccount.id === player._id ? currentClub.clubRole : parameters.accountTypeIds[player.typeId];

    return (
            <Link to={`/club/${clubId}/members/${player._id}`} className={`playerTab`}>
                <div className={`avatarContainer`}>
                    <Avatar data={avatar} />
                    <div className={`roleContainer ${role}`}>
                        <p className = {``} />
                    </div>
                </div>
                <div className={`clubInfo`}>
                    <span className={`clubName`}>{player.username}</span>
                    <p  className={`id`}>{t('id')}: {player.globalAccountId} / {player._id}</p>
                    <span className={`nickname`}>{t('nickname')}: <span>{player.nickname}</span></span>
                </div>
                <div className={'playerTab__value-container'}>
                    <div className={`fee`}>
                        {player[selectedField]}
                    </div>
                    {player.players !== undefined &&
                        <span className="playerTab__value-container__downline-count">
                            {t('downlines')}: {player.players -1}
                        </span>
                    }
                </div>
            </Link>
    );
};

export default PlayerTab;
